module.exports = __webpack_public_path__ + "static/banner-5e3f2f145db95059f41b87a42854bc44.png";